import React from 'react';
import AssetSelectModal from '../contentful/AssetSelectModal';
import ImageBlockUrlModal from './ImageBlockUrlModal';
import asset from '../../model/asset';
import tagModel from '../../model/tag';
import {useTagsHoC} from '../../providers/TagsProvider';
import './ImageBlock.scss';


class ImageBlock extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selecting: false,
      imageUrlEditor: false,
      uploading: false,
      isVideo: false,
      error: ''
    };

    this.toggleSelect = this.toggleSelect.bind(this);
    this.toggleUrlModal = this.toggleUrlModal.bind(this);
    this.handleSelection = this.handleSelection.bind(this);
    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.setImageUrl = this.setImageUrl.bind(this);
    this.toggleData = this.toggleData.bind(this);
  }

  toggleData(key, value) {
    this.props.onChange({
      data: {
        ...(this.props.block.data || {}),
        [key]: value
      }
    });
  }

  toggleSelect(e, type) {
    if (e) {
      e.preventDefault();
    }

    this.setState({
      selecting: !this.state.selecting,
      isVideo: type === 'video'
    });
  }

  toggleUrlModal(e) {
    if (e) {
      e.preventDefault();
    }

    this.setState({
      imageUrlEditor: !this.state.imageUrlEditor
    });
  }

  handleSelection(asset) {
    this.setState({
      selecting: false
    });

    this.props.onChange({
      image: asset
    });
  }

  async handleFileUpload(file) {
    this.setState({
      selecting: false,
      uploading: true,
      error: ''
    });

    let assetTagIDs = [];
    // If we are dealing with any predefined tags then we fetch existing tags, check which ones we already have and create the new ones.
    if (Array.isArray(this.props.predefinedTags) && this.props.predefinedTags.length > 0) {
      assetTagIDs = await tagModel.getOrCreateTagIdsFromTags(this.props.predefinedTags).catch(() => {
        this.setState({
          uploading: false,
          error: 'Feil ved opplasting av fil (Tag feilet). Ta kontakt!'
        });
        return null;
      });

      if (assetTagIDs === null) {
        return;
      }

      // Refresh the tags in the provider via the HOC.
      // Doing this async however if a race condition appears this can be awaited.
      this.props.tags.refreshTags();
    }

    return asset.upload({
      filename: file.name,
      contentType: file.type,
      content: file
    }, assetTagIDs).then((asset) => {
      this.handleSelection(asset);

      this.setState({
        uploading: false
      });
    });
  }

  setImageUrl(url, urlInTab) {
    this.props.onChange({
      url: url || null,
      urlInTab: (url && urlInTab) || null
    });
  }

  render() {
    const selector = <AssetSelectModal
      show={this.state.selecting}
      onSelect={this.handleSelection}
      onHide={this.toggleSelect}
      onFileSelected={this.handleFileUpload}
      isVideo={this.state.isVideo}
    />;

    if (!this.props.block.image) {
      return <div style={{textAlign: 'center', border: '1px dashed black'}}>
        {this.state.uploading && <div><i className="fa fa-spinner fa-pulse fa-fw"></i> Laster opp bilde...</div>}
        {this.state.error && <p><span className="text-danger">{this.state.error}</span></p>}
        <a href="#" onClick={(e) => this.toggleSelect(e, 'image')} disabled={this.state.uploading} className="btn btn-primary mf-margin-bottom-20 mf-margin-top-20">Velg bilde</a>
        {this.props.allowVideo && <a href="#" onClick={(e) => this.toggleSelect(e, 'video')} disabled={this.state.uploading} className="btn btn-primary mf-margin-bottom-20 mf-margin-top-20 mf-margin-left-10">Velg video</a>}
        {selector}
      </div>;
    }

    const isCurrentlyVideo = this.props.block.image.contentType.startsWith('video/');

    return (
      <div>
        <div className="mf-margin-bottom-20 mf-margin-top-10 form-inline">
          <a href="#" className="mf-margin-right-20" role="button" onClick={this.toggleUrlModal}>Lenke</a>
          <a href="#" className="mf-margin-right-20" role="button" onClick={(e) => this.toggleSelect(e, 'image')}>Bytt bilde</a>
          {this.props.allowVideo && <>
            <a href="#" className="mf-margin-right-20" role="button" onClick={(e) => this.toggleSelect(e, 'video')}>Bytt video</a>
            {isCurrentlyVideo && <>
              <div className="checkbox mf-margin-right-10"><label><input type="checkbox" value="" onChange={(e) => this.toggleData('autoplay', e.target.checked)} name="autoplay" defaultChecked={this.props.block.data?.autoplay} /> Autoplay</label></div>
              <div className="checkbox mf-margin-right-10"><label><input type="checkbox" value="" onChange={(e) => this.toggleData('loop', e.target.checked)} name="loop" defaultChecked={this.props.block.data?.loop} /> Loop</label></div>
              <div className="checkbox mf-margin-right-10"><label><input type="checkbox" value="" onChange={(e) => this.toggleData('muted', e.target.checked)} name="muted" defaultChecked={this.props.block.data?.muted} /> Muted</label></div>
            </>}
          </>}
          {this.props.allowFullwidth && <div className="checkbox"><label><input type="checkbox" value="" onChange={(e) => this.toggleData('fullwidth', e.target.checked)} name="fullwidth" defaultChecked={this.props.block.data?.fullwidth} /> Fullskjerm</label></div>}
        </div>
        {this.props.allowVideo && this.props.block.data?.autoplay && !this.props.block.data?.muted && <div>
          <div className="alert alert-info" role="alert">
            <strong>Obs!</strong> Autoplay uten muted vil ikke fungere i de fleste nettlesere. Se <a href="https://developer.mozilla.org/en-US/docs/Web/Media/Autoplay_guide" target="_blank" rel="noopener noreferrer">MDN</a> for mer informasjon.
          </div>
        </div>}
        <div className={`image-block-new ${this.props.block.url && 'image-block-link'}`} data-url={this.props.block.url}>
          {isCurrentlyVideo ?
            <video style={{maxWidth: '100%', height: 'auto', display: 'block'}} controls src={this.props.block.image.url}></video> :
            <img className="img-responsive" src={`${this.props.block.image.url}?fit=&w=640&h=380`} />
          }
          {selector}
          {this.state.imageUrlEditor && <ImageBlockUrlModal
            show={this.state.imageUrlEditor}
            onHide={this.toggleUrlModal}
            setUrl={this.setImageUrl}
            url={this.props.block.url}
            urlInTab={this.props.block.urlInTab}
          />}
        </div>
      </div>
    );
  }
}

export default useTagsHoC(ImageBlock);
